import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItCaptures from './components/HowItCaptures';
import Features from './components/Features';
import Privacy from './components/Privacy';
import HowItWorks from './components/HowItWorks';
import Experience from './components/Experience';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import DeleteAccount from './components/DeleteAccount';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}

function HomePage() {
  return (
    <main className="flex flex-col items-center flex-1 pt-[60px]">
      <Hero />
      <HowItCaptures />
      <Features />
      <Privacy />
      <HowItWorks />
      <Experience />
      <FAQ />
    </main>
  );
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background-light dark:bg-background-dark font-display text-slate-900 dark:text-white antialiased selection:bg-primary selection:text-background-dark overflow-x-hidden flex flex-col">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
